<template>
    <div class="user-row" :class="classes" @click="actionClick">
        <div class="circle">
            <div class="circle-mark"></div>
        </div>
        <span v-html="displayName"></span>
    </div>
</template>

<script>
    import AdminAccountPairUser from "./AdminAccountPairUser";

    export default {
        name: "MergeAccountsUser",
        mixins: [AdminAccountPairUser],
        computed: {
            userEmail() {
                return this.user.email ?? '';
            },
            displayName() {
                return this.userEmail;
            }
        }
    }
</script>